import ProtectedRouter from "@/context/auth/ProtectedRouter";
import { TenantProvider } from "@/context/TenantContext";
import { useTenant } from "@/context/useTenant";
import MainLayout from "@/layouts/MainLayout";
import StarterLayout from "@/layouts/StarterLayout";
import NotFoundPage from "@/pages/NotFoundPage";
import routes from "@/utils/routes";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";

function App() {
  return (
    <TenantProvider>
      <AppWithRouter />
    </TenantProvider>
  );
}

const AppWithRouter = () => {
  const { tenantId } = useTenant();

  // If no tenant ID is available, show a tenant selection page
  if (!tenantId) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold">Tenant ID Required</h1>
          <p className="text-gray-600">
            Please provide a tenant ID in the URL path (e.g.,
            /your-tenant-id/login)
          </p>
        </div>
      </div>
    );
  }

  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];
  return (
    <BrowserRouter basename={`/${tenantId}`}>
      <Routes>
        <Route element={<TopLevelComponent />}>
          {publicRoutes.map(({ path, element: Page }) => (
            <Route key={path} path={path} element={<StarterLayout />}>
              <Route index element={<Page />} />
            </Route>
          ))}

          {/* Protected routes */}
          <Route element={<ProtectedRouter />}>
            <Route element={<MainLayout />}>
              {authRoutes.map(({ path, element: Page }) => (
                <Route key={path} path={path} element={<Page />} />
              ))}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

const TopLevelComponent = () => {
  return <Outlet />;
};

export default App;
